import { CreateBrandModal } from '@/components/brand';
import { MenuRoot } from '@/components/ui/menu';
import { useOrganizationBrandsQuery } from '@/hooks/queries/use-organization-brands-query';
import { Box } from '@chakra-ui/react';
import React, { useState } from 'react';
import BrandMenu from './BrandMenu';
import BrandSelectorTrigger from './BrandSelectorTrigger';

interface BrandSelectorProps {
  isCollapsed?: boolean;
  /** When true, hide the selector if the user has only one brand */
  hideWhenSingleBrand?: boolean;
}

const BrandSelector: React.FC<BrandSelectorProps> = ({
  isCollapsed = false,
  hideWhenSingleBrand = false,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { data: brands } = useOrganizationBrandsQuery();

  if (hideWhenSingleBrand && (brands == null || brands.length <= 1)) {
    return null;
  }

  return (
    <Box>
      <MenuRoot>
        <BrandSelectorTrigger isCollapsed={isCollapsed} />
        <BrandMenu onCreateBrand={() => setIsCreateModalOpen(true)} />
      </MenuRoot>

      {/* Modal rendered outside MenuRoot to avoid click conflicts */}
      <CreateBrandModal isOpen={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)} />
    </Box>
  );
};

export default BrandSelector;
